import MuiTypography, { TypographyProps } from '@mui/material/Typography';

export interface ITypographyProps extends TypographyProps {}

const Typography = (props: ITypographyProps): JSX.Element => {
  return <MuiTypography {...props} />;
};

export default Typography;
